import { jsx as _jsx } from "react/jsx-runtime";
import { Drawer, makeStyles } from '@material-ui/core';
import { useDrawerContext } from '../../../context';
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
    },
    body: {
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(0),
    },
    paper: ({ width }) => ({
        width: '100%',
        maxWidth: width,
    }),
}));
const sizeMap = {
    large: 960,
    medium: 720,
    small: 560,
    fullWidth: 1920,
};
/**
 * DrawerContainer component for the Drawer.
 *
 * This component renders the container for the Drawer.
 * The container can contain any content, such as text or form fields.
 *
 *  Size options:
 *  large: 960,
 *  medium: 720,
 *  small: 560,
 *  fullWidth: 1920,
 *
 * @param {DrawerContainerProps} props
 */
export const DrawerContainer = ({ children, disableBackdropClick = false, disableEscapeKeyDown = false, size = 'medium', anchor = 'right', testId = 'drawer-container', ...drawerProps }) => {
    const width = typeof size === 'number' ? size : sizeMap[size];
    const classes = useStyles({ width });
    const context = useDrawerContext();
    return (_jsx(Drawer, { disableBackdropClick: disableBackdropClick, disableEscapeKeyDown: disableEscapeKeyDown, anchor: anchor, open: context.isDrawerOpen, className: classes.body, classes: { paper: classes.paper }, ...drawerProps, children: _jsx("div", { style: { maxWidth: width }, className: classes.root, "data-testid": testId, children: children }) }));
};
